<sdc-bo-dialog
  [headerTitle]="'Edit Event ' + (type | titlecase)"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'event-edit-modal-' + event?.id">
  @if (event) {
    <div class="content-wrapper">
      <div class="mt-6">
        <div class="input-line">
          <div>
            <span><b>Event</b></span>
          </div>
          <div class="input-line-value">
            <span
              >{{ event?.code ?? 'No code' }} :
              {{ event?.description ?? 'No description' }}</span
            >
          </div>
          <div class="mt-4">
            @switch (type) {
              @case ('upsell') {
                <div>
                  <span>Select from the Upsells List</span>
                  <gs-selectable-list
                    [items]="upsellList?.data ?? []"
                    titleKey="name"
                    subtitleKey="description"
                    imageKey="urlImage"
                    [searchable]="false"
                    [loading]="isListLoading"
                    [ngModel]="selectedIds"
                    (ngModelChange)="onSelectionChange($event)" />
                </div>
              }
              @case ('upgrade') {
                <div>
                  <span>Select from the Upgrade List</span>
                  <gs-selectable-list
                    [items]="upgradeList?.data ?? []"
                    titleKey="name"
                    subtitleKey="description"
                    [searchable]="false"
                    [loading]="isListLoading"
                    [ngModel]="selectedIds"
                    (ngModelChange)="onSelectionChange($event)" />
                </div>
              }
              @case ('adlink') {
                <div>
                  <span>Select up to 2 AdLinks</span>
                  @if (adlinkLimitReached) {
                    <p class="text-[#dc3545] mt-2 mb-0">
                      An event can have at most 2 ad links.
                    </p>
                  }
                  <gs-selectable-list
                    [items]="adLinkList?.data ?? []"
                    titleKey="name"
                    subtitleKey="title"
                    imageKey="urlImage"
                    [searchable]="false"
                    [loading]="isListLoading"
                    [disabledIds]="adlinkDisabledIds"
                    [ngModel]="selectedIds"
                    (ngModelChange)="onSelectionChange($event)" />
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button variant="primary" (onClick)="onConfirm()">
      Save & Publish
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
